// extracted by mini-css-extract-plugin
export default {"imageContainer":"D0-z","summaryPar":"E0-z","ratingCategories":"F0-z","reviewerInfo":"G0-z","reviewTypes":"H0-z","expanded":"I0-z"};